import React, { useState } from "react";

import * as SC from "./PadBanner.styled";
import { ChevronDownIcon, ChevronUpIcon } from "../Icons";

type PadBannerProps = {
    title: string;
    label?: React.ReactNode;
    href?: string;
    children?: React.ReactNode;
    isExpress?: boolean;
}

const PadBanner: React.FC<PadBannerProps> = ({ title, isExpress, children }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const handleContentExpand = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        event.stopPropagation();

        setIsExpanded(value => !value);
    };

    return <SC.Wrapper>
        <SC.InnerWrapper data-testid="pad-banner">
            <SC.ContentWrapper data-testid={`pad-banner-content-${isExpress ? 'express' : 'classic'}`}>
                <SC.ExpandIcon href="#" onClick={handleContentExpand}>{isExpanded ? <ChevronDownIcon /> : <ChevronUpIcon />}</SC.ExpandIcon>
                <SC.Content>
                    <SC.Title>{title}</SC.Title>
                    {isExpanded && children}
                </SC.Content>
                {isExpanded && <SC.ImageWrapper hasPlaceholder={!isExpress}>
                    <img src={`/assets/icons/checkout-${isExpress ? 'express' : 'standart'}.svg`} alt="Banner image" />
                </SC.ImageWrapper>}
            </SC.ContentWrapper>
            <SC.Placeholder />
        </SC.InnerWrapper>
    </SC.Wrapper>;
};

export default PadBanner;